import { apiClient } from "@/lib/apiClient";

export const dashboardService = {
  async get() {
    const { data } = await apiClient.get("/dashboard");
    return data;
  },
};
